import { IApplicationState } from '../../types/redux';
import { IShareFieldRealtorsAndAgencies } from '../../types/redux/shareRealtorsAndAgencies';

/**
 * Достаем из стора по id риелтора или агентство,
 * берем урл для картинки и его первую букву из имени/названия
 */
export function getPreviewImage(cianUserId: number) {
  return (state: IApplicationState) => {
    const { tab } = state;
    const listingItems = (state[tab] as IShareFieldRealtorsAndAgencies).listing.items;
    const item = listingItems.find(item => item.cianUserId === cianUserId);
    const imgUrl = item?.avatarUrl || null;
    const firstLetter = item?.name.substr(0, 1).toUpperCase() || null;

    return {
      imgUrl,
      firstLetter,
    };
  };
}
